import axios from 'axios'
import { snakeCase } from "change-case";
import queryString from 'query-string';

const removeEmpty = (obj) => {
  return Object.entries(obj)
    .filter(([_, v]) => v != null)
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
}

const isArray = (a) => Array.isArray(a);

const isObject = (o) => o === Object(o) && !isArray(o) && typeof o !== 'function';

const keysToSnake = (o) => {
  if (isObject(o)) {
    return Object.entries(o).reduce((acc, [k, v]) => ({ ...acc, [snakeCase(k)]: keysToSnake(v) }), {})

  } else if (isArray(o)) {
    return o.map((i) => keysToSnake(i));
  }

  return o;
};

export const apiClient = axios.create({ baseURL: process.env.BASE_URL });

export const buildQueryString = (params, removeEmptyAttributes = true) => {
  if (params && Object.keys(params).length > 0) {
    const queryParams = removeEmptyAttributes ? removeEmpty(params) : params

    return '/?' + queryString.stringify(keysToSnake(queryParams), { arrayFormat: 'bracket' })
  } else {
    return '/'
  }
};



// WEBPACK FOOTER //
// ./src/services/utils.js